// extracted by mini-css-extract-plugin
export default {"card":"ContentCard_card__Ak+cL"};